import { FieldLabel } from "@smartsuite/react-ui/lib/components/forms/FieldLabel/FieldLabel";
import { InputGroup } from "@smartsuite/react-ui/lib/components/forms/InputGroup/InputGroup";
import { useCallbackDebounce } from "@smartsuite/react-ui/lib/hooks/useCallbackDebounce/useCallbackDebounce";
import React, { memo, useRef } from "react";
import { DocumentDesignItem, ImageItem } from "../../canvas/state/types";
import { TextFieldInput } from "./TextFieldInput/TextFieldInput";
import { RenderContext } from "../../canvas/renderer/fabric-renderer";
import { isValidUrl } from "../../helpers/url";

export interface SidebarSelectionConfigImageProps {
  context: RenderContext;
  selected: ImageItem;
  onChangeSelected: (modifiedItem: DocumentDesignItem) => void;
}

const SidebarSelectionConfigImageRaw: React.FC<
  SidebarSelectionConfigImageProps
> = ({ context, selected, onChangeSelected }) => {
  const requestIdRef = useRef(0);

  // @ts-expect-error need to solve type issue
  const handleUpdateUrl = useCallbackDebounce((url: string) => {
    const currentRequestId = ++requestIdRef.current;

    if (!url) {
      onChangeSelected({ ...selected, url: undefined, handle: undefined });
    } else if (isValidUrl(url)) {
      // mark the image that can now be loaded
      onChangeSelected({ ...selected, url, handle: undefined });

      context.filestack?.storeURL(url).then(
        (res) => {
          if (currentRequestId === requestIdRef.current) {
            const { handle } = res as { handle: string };
            onChangeSelected({ ...selected, url, handle });
          }
        },
        () => {
          if (currentRequestId === requestIdRef.current) {
            // mark the image that has error
            onChangeSelected({ ...selected, url, handle: null });
          }
        },
      );
    }
  }, 500);

  return (
    <>
      <div>
        <FieldLabel>Image URL</FieldLabel>
        <InputGroup>
          <TextFieldInput
            placeholder="http://"
            pattern="https?://.+"
            type="url"
            value={selected.url ?? ""}
            onChangeValue={handleUpdateUrl}
          />
        </InputGroup>
      </div>
    </>
  );
};

export const SidebarSelectionConfigImage = memo(SidebarSelectionConfigImageRaw);
